import { useTracking } from '@edreamsodigeo/frontend-core';
import { useMemo } from 'react';

const EVENTS = {};

const CATEGORY = 'flights_results';
const ACTION = 'price-freeze';

export function usePFTracking(id) {
  const { trackEvent } = useTracking();

  return useMemo(
    () => ({
      trackLoadOnce(label) {
        if (!EVENTS[id]) {
          trackEvent({
            category: CATEGORY,
            action: ACTION,
            label,
          });
          EVENTS[id] = true;
        }
      },
      trackClick(label) {
        trackEvent({
          category: CATEGORY,
          action: ACTION,
          label,
        });
      },
    }),
    [id, trackEvent]
  );
}
